import React from "react";

interface TooltipProps {
    //   content: React.ReactNode; // Content of the tooltip
    title?: string;
    description?: string;
    children: React.ReactNode; // The target element that will have the tooltip
}

const Tooltip: React.FC<TooltipProps> = ({ title, description, children }) => {
    const [isVisible, setIsVisible] = React.useState(false);

    const showTooltip = () => setIsVisible(true);
    const hideTooltip = () => setIsVisible(false);

    return (
        <div
            onMouseEnter={showTooltip}
            onMouseLeave={hideTooltip}
            style={{ position: "relative", display: "inline-block" }}
        >
            {children}
            {isVisible && (
                <>
                    <div
                        className="bg-secondary-gray-dark text-system-white p-16 w-372 rounded-lg mb-8"
                        style={{
                            position: "absolute",
                            bottom: "calc(100% + 8px)",
                            left: "50%",
                            transform: "translateX(-50%)",
                            zIndex: 1000
                        }}
                    >
                        {title && (
                            <div className="text-sm font-semibold">{title}</div>
                        )}
                        {description && (
                            <div className="text-sx font-normal">
                                {description}
                            </div>
                        )}
                    </div>
                    <div
                        className="border-secondary-gray-dark"
                        style={{
                            position: "absolute",
                            bottom: "calc(100% + 8px)",
                            left: "50%",
                            transform: "translateX(-50%)",
                            width: "0",
                            height: "0",
                            borderLeft: "10px solid transparent",
                            borderRight: "10px solid transparent",
                            borderTop: "10px solid"
                        }}
                    ></div>
                </>
            )}
        </div>
    );
};

export default Tooltip;
